import { Component, HostListener, ViewChild } from '@angular/core';
import { SsoService } from '@app/core/sso.service';
import { NotificationListDrawerComponent } from '@app/pages/notification/notification-list-drawer/notification-list-drawer.component';

@Component({
    selector: 'app-notification-bell',
    templateUrl: './notification-bell.component.html',
    styleUrls: ['./notification-bell.component.scss'],
    standalone: false,
})
export class NotificationBellComponent {
    @ViewChild('notificationListDrawer') notificationListDrawer!: NotificationListDrawerComponent;

    unreadCount = 0;

    private enterpriseOrigin = '';

    constructor(private ssoService: SsoService) {
        this.enterpriseOrigin = this.ssoService.getEnterpriseOrigin();
    }

    @HostListener('window:message', ['$event'])
    onMessage(event: MessageEvent): void {
        if (event.origin !== this.enterpriseOrigin) return;
        if (event.data?.type === 'NOTIFICATION_COUNT') {
            this.unreadCount = event.data.unreadCount ?? 0;
        }
    }

    openDrawer(): void {
        this.notificationListDrawer?.open();
    }
}
